/** @jsxImportSource @emotion/react */

import { Interpolation, Theme, css } from "@emotion/react";

import { Tooltip as MuiTooltip } from "@mui/material";
import { theme } from "styles/theme";
import IconV2 from "uis/Icon/Icon_v2/icon";

export default function Tooltip({ title, styles, explain, isDisabled=false }: { title?: string; styles?: Interpolation<Theme>; explain: string, isDisabled?: boolean }) {
    return (
        <MuiTooltip
            title={
                <p
                    css={css`
                        font-size: 14px;
                    `}
                >
                    {explain}
                </p>
            }
        >
            <div
                css={[
                    css`
                        display: flex;
                        gap: 4px;
                        align-items: center;

                        color: ${theme.neutral500};
                        font-size: 15px;
                        font-weight: 500;

                        &:hover {
                            color: ${theme.neutral600};
                        }
                    `,
                    styles,
                ]}
            >
                {title}
                <IconV2
                    color={isDisabled ? "var(--alias-color-label-disabled)" : "var(--alias-color-label-assistive)"}
                    name="question"
                    size={20}
                    style={{lineHeight: 0}}
                />
            </div>
        </MuiTooltip>
    );
}
